module.exports = __webpack_public_path__ + "img/9.366e6335.jpg";